import { StarOutlined } from '@ant-design/icons';

import Section from 'layouts/Section/Section';

import ResponsiveCarousel from 'components/ResponsiveCarousel/ResponsiveCarousel';
import Title from 'components/Title/Title';

import { CAROUSEL_AUTOPLAY_SPEED_MS } from 'constants/commons';

import Card from './Card';
import items from './items';
import styles from './styles.module.scss';

const Testimonials = () => (
  <Section background="--brand-primary-lighten" className={styles.wrap}>
    <Title
      title="Hear what our wonderful customers say"
      className={styles.title}
    />
    <ResponsiveCarousel
      responsive={[
        { breakpoint: 1800, settings: { slidesToShow: 4 } },
        { breakpoint: 1400, settings: { slidesToShow: 3 } },
        { breakpoint: 1080, settings: { slidesToShow: 2 } },
        { breakpoint: 680, settings: { slidesToShow: 1 } }
      ]}
      slidesToShow={5}
      centerMode={true}
      className={styles.carouselContainer}
      adaptiveHeight={false}
      autoplay
      autoplaySpeed={CAROUSEL_AUTOPLAY_SPEED_MS}
    >
      {items.map((testimonial, index) => (
        <Card
          key={index}
          name={testimonial.name}
          title={testimonial.title}
          company={testimonial.company}
          testimonial={testimonial.testimonial}
        />
      ))}
    </ResponsiveCarousel>
  </Section>
);

export default Testimonials;
